import React, { startTransition } from "react";
import { useNavigate } from "react-router-dom";
import CustomListItem from "../common/CustomListItem";
import CustomListItemButton from "../common/CustomListItemButton";

interface NavigationElementProps {
  title: string;
  route: string;
  icon: any;
  disabled: boolean;
}

const NavigationElement: React.FC<NavigationElementProps> = ({
  title,
  route,
  icon,
  disabled,
}) => {
  const navigate = useNavigate();

  const handleNavigation = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    startTransition(() => {
      navigate(route);
    });
  };

  return (
    <CustomListItem route={route} disabled={disabled}>
      <CustomListItemButton
        title={title}
        route={route}
        icon={icon}
        onClick={handleNavigation}
        disabled={disabled}
      />
    </CustomListItem>
  );
};

export default NavigationElement;
